import create from 'zustand';

import { CombinedApiResponse } from 'hooks/useFetchScriptVariables';

export interface AddressComponent {
  long_name?: string;
  short_name?: string;
  types?: string[];
}

export interface SearchStoreType {
  response: CombinedApiResponse;
  setResponse: (response: CombinedApiResponse) => void;
  resetState: () => void;
}

const initialResponseState: CombinedApiResponse = {
  geodata: null,
  landmark: null,
  streetview: null,
  weather: null,
  region: 'AUS-WIDE',
  coreLogic: {
    coreAttributes: null,
    additionalAttributes: null,
    propertyAge: null,
    reaHomeType: null,
  },
  hardwareStores: {
    stores: null,
    attributions: null,
  },
  risks: null,
  buildingName: null,
  buildingAnimations: null,
};

export const useResponseStore = create<SearchStoreType>(set => ({
  response: { ...initialResponseState },
  setResponse: nextResponse => set({ response: nextResponse }),
  resetState: () => set({ response: { ...initialResponseState } }),
}));

export default useResponseStore;
